module.exports = __webpack_public_path__ + "img/ordenacao.d3d133b1.svg";